import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking';
import {
	CATEGORY_TYPE,
	ASSIGNEE_TYPE,
	PRIORITY_TYPE,
	STATUS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	NUMBER_CF_TYPE,
	SPRINT_TYPE,
} from '@atlassian/jira-platform-field-config';

export const LIST_PADDING_LEFT = 20;
export const LIST_ROW = 'listRow';
export const DEFAULT_ROW_HEIGHT = 40;
export const LOADING_ITEMS_COUNT = 50;
export const ROW_KEY = 'rowKey';
export const SELECT_ROW_COLUMN_WIDTH = 65;
export const TYPE_CELL_LEFT_PADDING = 35;
// icon width 16px + 4px margin right
// this is used to indent expand icon
export const EXPAND_ICON_INDENT_WIDTH = 20;
export const FOOTER_HEIGHT = 45;

export const zIndex = {
	tableFooter: 1,
	tableShadow: 2,
	inlineFieldCreateControls: 3,
};

export const LIST_FIELD_POPUP_OFFSET: [number, number] = [0, -DEFAULT_ROW_HEIGHT];

export const TAG_LIST_WRAPPER_CLASS_NAME = 'tag-wrapper-highlight-on-hover';
export const DATE_LOZENGE_ID = 'list-date-lozenge';
export const CHILD_CREATE_BTN_WRAPPER = 'child-create-btn-wrapper';

// cellNavigation
export const UP = 'up';
export const DOWN = 'down';
export const LEFT = 'left';
export const RIGHT = 'right';

export const BULK_SELECT_CHECKBOX_ID = 'bulk-select-checkbox';

export const DRAG_AND_DROP_BUTTON_FOCUS_EVENT = 'drag-and-drop-button-focus';

export const DEFAULT_FOOTER_HEIGHT = 45;
export const ACTION_DRAG_STARTED = 'dragStarted';
export const ACTION_DRAG_ENDED = 'dragEnded';
export const NO_ISSUE_TYPE = 'noIssueType';
export const NO_PARENT_ISSUE_TYPE = 'noParentIssueType';
export const TOP_LEVEL_COLLECTION = 'topLevelCollection';

export const BULK_DELETE_IN_PROGRESS_FLAG_ID = 'bulk-delete-in-progress-flag';
export const BULK_DELETE_SUCCESS_FLAG_ID = 'bulk-delete-success-flag';
export const BULK_DELETE_FAILED_FLAG_ID = 'bulk-delete-failed-flag';
export const BULK_DELETE_FAILED_CLIENT_FLAG_ID = 'bulk-delete-failed-client-flag';

export const VIEW_EXPERIENCE: ExperienceDetails = {
	experience: 'listView',
	experienceId: 'main',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const LOAD_CHILDREN_EXPERIENCE: ExperienceDetails = {
	experience: 'loadChildren',
	experienceId: 'children',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const LOAD_GROUP_ITEMS_EXPERIENCE: ExperienceDetails = {
	experience: 'loadGroup',
	experienceId: 'groupItems',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const LOAD_GROUP_ITEMS_CHILDREN_EXPERIENCE: ExperienceDetails = {
	experience: 'loadGroupChildren',
	experienceId: 'groupItemsChildren',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const BULK_DELETE_EXPERIENCE: ExperienceDetails = {
	experience: 'bulkDelete',
	experienceId: 'bulkDelete',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const BULK_COPY_EXPERIENCE: ExperienceDetails = {
	experience: 'bulkCopy',
	experienceId: 'bulkCopy',
	packageName: 'jiraBusinessList',
	teamName: 'keystone',
};

export const CREATE_CATEGORY_EXPERIENCE: ExperienceDetails = {
	experience: 'createCategory',
	experienceId: 'createCategory',
	packageName: 'jiraBusinessList',
	teamName: 'jira-warepil',
};

export const UPDATE_CATEGORY_EXPERIENCE: ExperienceDetails = {
	experience: 'updateCategory',
	experienceId: 'updateCategory',
	packageName: 'jiraBusinessList',
	teamName: 'jira-warepil',
};

export const DELETE_CATEGORY_EXPERIENCE: ExperienceDetails = {
	experience: 'deleteCategory',
	experienceId: 'deleteCategory',
	packageName: 'jiraBusinessList',
	teamName: 'jira-warepil',
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const SUPPORTED_GROUPS_TYPES = [
	ASSIGNEE_TYPE,
	PRIORITY_TYPE,
	STATUS_TYPE,
	CATEGORY_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	NUMBER_CF_TYPE,
	SPRINT_TYPE,
] as string[];
